import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
    site: SiteModel
}
const Telecom: FC<Props> = ({ site }) => {

    var formattedDate = '';

    if (site.telecom != null || site.telecom != undefined) {
        formattedDate = site.telecom === '0001-01-01T00:00:00' ? '' : new Date(site.telecom).toLocaleDateString('tr-TR');
    }

    return (
        <div className='d-flex align-items-center'>
            {formattedDate}
        </div>
    )

}
export { Telecom }
